import axios from 'axios'
import debounce from 'lodash/debounce'

export class ProductArchive {
    constructor() {
        this.productArchiveEl = document.getElementById('product-archive');
        this.productActiveFiltersEl = document.getElementById('product-active-filters')
		this.noProductsEl = document.getElementById('no-products-found');
        this.bannerEl = document.getElementById('product-banner')
        this.loaderEl = this.productArchiveEl.querySelector('.sf-loader')
        this.ctaEl = null
        this.products = []
        this.productCardEls = []
        this.productsContainerEl = document.getElementById('product-results')
        this.ctaContainer = document.getElementById('cta-container')
        this.filterProductArchiveButton = document.getElementById('filter-product-archive')
        this.loadMoreButton = document.getElementById('load-more-products')
        this.productBannerEl = document.getElementById('product-banner')
        this.productBannerSubtitleEl = document.getElementById('product-banner-subtitle')
        this.productBannerTitleEl = document.getElementById('product-banner-title')
        this.filters = []
        this.activeFilterTags = []
        this.searchInput = document.querySelector('#product-text-search input.search-form-input')
        this.searchQuery = null
        this.totalCount = 0
        this.baseCount = 9
        this.start = 0
        this.ipp = 27
        this.currentBanner = document.querySelector('#product-banner .products-banner__banner')
        this.newBanner = null
        this.newBannerFadeInDuration = 1000
		this.params = {};

        this.init()
    }

    init() {



        this.setupFilters()

        this.setupSearch()



		// When page initializes, check if the current url has filtering enabled
        const locationHref = window.location.href;
		if ( locationHref.indexOf("?") > -1 ) {
			// Get the query string
			const query_string = locationHref.split('?').pop();
			// Spilt it.
			const paramStringArray = query_string.split('&');
			// For each variable turn it into an array based on commas
			paramStringArray.forEach((string) => {
				const split = string.split('=');
				if ( split[0] ) this.params[split[0]] = split[1].split(',');
			});

			// Black Airplane's script just lumps all filters together, so build a new array that does that
			// TODO - Make this meaningful.
			let allValues = [];
			for ( const key in this.params ) {
				if ( key != 'search' ) {
					allValues = allValues.concat(this.params[key]);
				}
			}
			this.filters.forEach(filter => {
				if ( allValues.find(listedValue => listedValue === filter.slug) ) {
					this.toggleFilter(filter.termId, true);
				}
			});

			// If there is a search query, set it
			if ( this.params.search ) {
				this.searchInput.value = window.decodeURIComponent(this.params.search);
				this.searchQuery = window.decodeURIComponent(this.params.search);
			}
		}

		// Listeners
		this.filterProductArchiveButton.addEventListener('click', (e) => {
			e.preventDefault();
			this.getProducts();
		});
		this.loadMoreButton.addEventListener('click', () => {
			this.loadMore();
		});
		// Finally get the products
		this.getProducts();
	}

    setupFilters() {
        console.log('Setting up filters');
        document.querySelectorAll('.archive-filter').forEach(productArchiveFilter => {
            const taxonomy = productArchiveFilter.dataset.taxonomy
            const termId = productArchiveFilter.dataset.termId
            const label = productArchiveFilter.dataset.label
            const slug = productArchiveFilter.dataset.slug
            const taxonomyLabel = productArchiveFilter.dataset.taxonomyLabel

            productArchiveFilter.addEventListener('click', () => {
                this.toggleFilter(termId)
            })

            this.filters.push({
                el: productArchiveFilter,
                taxonomy: taxonomy,
                termId: termId,
                selected: false,
                label: label,
                slug: slug,
                taxonomyLabel: taxonomyLabel
            })
        })
    }

	// Update the URL with the current filters and search query
	updateUrl() {
		// Update the query string with the current filters
		const newQueryString = [];
		this.filters.forEach(filter => {
			if ( filter.selected ) {
				newQueryString.push(`${filter.taxonomy}=${filter.slug}`);
			}
		});

		// Update the query string with the current search query
		if ( this.searchQuery ) {
			newQueryString.push(`search=${this.searchQuery}`);
		}

		// Update the url
		let newUrl = `${window.location.origin}${window.location.pathname}`;
		if ( newQueryString.length > 0 ) newUrl += `?${newQueryString.join('&')}`;
		window.history.pushState({}, '', newUrl);
        // Trigger GA pageview for the new URL
        analytics.track.client("page_view", { page_title: document.title, page_location: newUrl }, ["googleAnalytics"]);
      }

    setupSearch() {
        const debounceSearch = debounce((e) => {
            this.start = 0
            this.searchQuery = e.target.value
            this.getProducts()
			// Update the url with the search query
			this.updateUrl();
            // Track the search event
            analytics.track.client("product_search", { event_category: "search", search_term: this.searchQuery }, ["googleAnalytics"]);
        }, 350)

        this.searchInput.addEventListener('input', debounceSearch)
    }

    loadMore() {
        if (this.start === 0) {
            this.start = this.baseCount
        } else {
            this.start = this.start + this.ipp
        }

        this.getProducts()
    }

    getProducts() {
        this.loaderEl.classList.add('sf-loader--loading')
 
        if (this.start === 0) {
            this.productsContainerEl.innerHTML = ''
        }

        const filterData = []

        this.filters.forEach(filter => {
            if (filter.selected) {
                filterData.push({
                    taxonomy: filter.taxonomy,
                    term_id: filter.termId
                })
            }
        })

        axios.post(window.sanderson_farms.resturl + 'sanderson-farms/v1/products/', {
            filters: filterData,
            offset: this.start,
            s: this.searchQuery
        }, {
            headers: {
            }
        }).then((response) => {
            if (this.start === 0) {
                this.products = response.data.products
            } else {
                this.products.push(...response.data.products)
            }

            this.bannerData = response.data.banner_data
            this.totalCount = response.data.total_count

            this.stopLoading()

			// If we have zero recipes, show the no recipes message
			if ( this.totalCount === 0 ) {
				this.noProductsEl.classList.remove('hidden');
			} else {
				this.noProductsEl.classList.add('hidden');
				this.renderResults(response.data.products);
			}

            // this.renderBanner()

            if (this.products.length >= this.totalCount) {
                this.loadMoreButton.style.display = 'none'
            } else {
                this.loadMoreButton.style.display = 'block'
            }
        }).catch(e => {
            this.stopLoading()
        })
    }

    stopLoading() {
        this.loaderEl.classList.remove('sf-loader--loading')
    }

    renderResults(results) {
        if (this.start === 0) {
            this.productsContainerEl.innerHTML = ''
        }

        this.productCardEls = []

        let i = 0;
        const rpcGrid = document.getElementById('rcp-grid');
        const buyNowText = rpcGrid.dataset.textBuyNow || 'Buy Now';
        const moreInfoText = rpcGrid.dataset.textMoreInfo || 'More Info';

        results.forEach(product => {
            const productCardEl = document.createElement('div');
            productCardEl.classList.add("product-card");

            const productThumbnailEl = document.createElement('div');
			let thumbEl = '';
			thumbEl += '<div class="callout-image">';
			thumbEl += '<a href="'+ product.link +'"><img class="img-responsive" src="'+ product.thumbnail[0]['1x']['url'] +'"></a>';
			thumbEl += '</div>';
			thumbEl += '<div class="callout-title">';
			thumbEl += '<a href="'+ product.link +'">'+ product.title +'</a>';
			thumbEl += '</div>';
			thumbEl += '<div class="callout-buttons">';
			thumbEl += '<a href="'+ product.link +'" class="btn product-info-btn">'+ moreInfoText +'</a>';
			if ( product.adimo_identifier ) thumbEl += '<div class="btn product-buy-btn adimoWidget" data-type="lightbox" data-static-touchpoint-identifier="'+ product.adimo_identifier +'"><span>'+ buyNowText +'</span></div>'; 
			thumbEl += '</div>';
            productThumbnailEl.innerHTML = thumbEl;

            productCardEl.appendChild(productThumbnailEl);

            this.productsContainerEl.appendChild(productCardEl);
            this.productCardEls.push(productCardEl);
            window.getComputedStyle(productCardEl).opacity

            productCardEl.classList.add('product-card--loaded', 'product-card--' + i)

            i++;
        })
    }



    renderBanner() {
        this.newBanner = document.createElement('div')
        this.newBanner.classList.add('products-banner__banner')
        const newBannerSubtitle = document.createElement('h5')
        const newBannerTitle = document.createElement('h1')
        newBannerTitle.classList.add('headline');

        newBannerTitle.innerHTML = this.bannerData.title
        newBannerSubtitle.innerHTML = this.bannerData.subtitle
        this.newBanner.style.backgroundImage = 'url(' + this.bannerData.image + ')'

        this.newBanner.appendChild(newBannerSubtitle)
        this.newBanner.appendChild(newBannerTitle)

        this.bannerEl.appendChild(this.newBanner);
        window.getComputedStyle(this.newBanner).opacity



        this.newBanner.classList.add('products-banner__banner--show')

        setTimeout(() => {
            this.currentBanner.remove()

            this.currentBanner = this.newBanner
        }, this.newBannerFadeInDuration)
    }

    toggleFilter(termId, initLoad = false) {
        this.start = 0

        const filterIndex = this.filters.findIndex(filter => filter.termId === termId)
        this.filters[filterIndex].el.classList.add('active-recipe')

        this.filters[filterIndex].selected = !this.filters[filterIndex].selected

        this.renderActiveFilters()

        // If this filter was removed, then remove the Active Filter Tag as well
        if (!this.filters[filterIndex].selected) {
            const activeFilterIndex = this.activeFilterTags.findIndex(activeFilterTag => activeFilterTag.termId === termId)

            this.activeFilterTags[activeFilterIndex].el.remove()
            this.activeFilterTags.splice(activeFilterIndex, 1)

            // Also uncheck input
            this.filters[filterIndex].el.checked = 0
            this.filters[filterIndex].el.classList.remove('active-recipe')

        }

		// If it is not the inital load, get the newly matching recipes and update the URL.
		if ( !initLoad ) {
			this.getProducts();
			this.updateUrl();
		}
    }

    renderActiveFilters() {
        const activeFilters = this.filters.filter(filter => filter.selected)

        activeFilters.forEach(activeFilter => {
            const filterIndex = this.activeFilterTags.findIndex(activeFilterTag => activeFilterTag.termId === activeFilter.termId)

            if (filterIndex < 0) {
                const activeFilterEl = document.createElement('div')
                const activeFilterLabelEl = document.createElement('div')
                const activeFilterTaxonomyLabelEl = document.createElement('div')

                activeFilterEl.classList.add('filter-tags__tag')
                activeFilterLabelEl.classList.add('filter-tags__label')
                activeFilterTaxonomyLabelEl.classList.add('filter-tags__taxonomy-label')

                activeFilterTaxonomyLabelEl.innerHTML = activeFilter.taxonomyLabel + ':'
                activeFilterLabelEl.innerHTML = activeFilter.label + '&nbsp x'

                activeFilterEl.appendChild(activeFilterTaxonomyLabelEl)
                activeFilterEl.appendChild(activeFilterLabelEl)

                this.productActiveFiltersEl.appendChild(activeFilterEl)

                activeFilterEl.addEventListener('click', () => {
                    this.toggleFilter(activeFilter.termId)
                })

                this.activeFilterTags.push({
                    el: activeFilterEl,
                    termId: activeFilter.termId
                })
            }
        })
    }

}